// Инициализация попапов fancybox

app.modules.initFancybox = (function (self) {
  function _init() {
    var $fancybox = $('.js-fancybox');
    $fancybox.length && $fancybox.fancybox();
  }

  self.load = function () {
    _init();
  };

  return self;
})(app.modules.initFancybox || {});
